<script>
export default {
  ErrorMsg (error, type, context) {
    return context.$buefy.dialog.alert({
      type: type,
      message: error,
      hasIcon: true,
      animation: 'zoom-out',
      size: 'is-medium',

      icon: ' mdi-exclamation',
      iconPack: 'mdi',
      ariaRole: 'alertdialog',
      ariaModal: true
    })
  }
}
</script>
